import axiosInstance from "../utils/axios";

const BASE_URL = "/purchases/v1";

interface IStartPurchaseByQuoteData {
  quoteId: string;
}

async function startPurchaseByQuote(data: IStartPurchaseByQuoteData) {
  return axiosInstance.post(`${BASE_URL}/quote/start`, data, {});
}

interface ICreatePurchaseByQuoteData {
  emailAddress: string;
  paymentIntentId: string;
  paymentProvider: string;
  paymentProviderToken: string | null;
  quoteId: string;
  metadata: {[key: string]: any};
}

async function createPurchaseByQuote(data: ICreatePurchaseByQuoteData, language: string | null) {
  return axiosInstance.post(`${BASE_URL}/quote${language ? '?locale=' + language + '_nz' : ''}`, data, {})
}

export {
  startPurchaseByQuote,
  createPurchaseByQuote
}